import type { GraphQLError } from "graphql";
import type { ClientError } from "graphql-request";

/** Codes app-api sets in a GraphQL error's `extensions.code`. */
export const RATE_LIMITED_ERROR_CODE = "RATE_LIMITED";

/**
 * graphql-request rejects with ClientError when the response carries top-level
 * `errors`, including on HTTP 200.
 */
export function isClientError(error: unknown): error is ClientError {
  return error instanceof Error && "response" in error;
}

/**
 * First top-level GraphQL error, or undefined when the failure was a network or
 * client-side error rather than a GraphQL one. Prefer this over ClientError's
 * own `message`, which appends a JSON dump of the response and request.
 */
export function firstGraphqlError(error: unknown): GraphQLError | undefined {
  return isClientError(error) ? error.response?.errors?.[0] : undefined;
}

/** `extensions.code` of the first GraphQL error, when it is a string. */
export function graphqlErrorCode(error: unknown): string | undefined {
  const code = firstGraphqlError(error)?.extensions?.code;
  return typeof code === "string" ? code : undefined;
}

export class IncompleteProfileError extends Error {
  constructor() {
    super("Profile is incomplete");
  }
}

export class NotLoggedInError extends Error {
  constructor() {
    super("Not logged in");
  }
}
